import Grid from '../components/grid'
import Container from '../components/ui/container'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetType } from '@telesoft/types/payload-types'
import React from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'full-width-image' }>

export default function FullWidthImage(block: BlockProps) {
  const { image } = block

  return (
    <Container>
      <Grid>
        <div
          style={{ height: '100%', width: '100%', position: 'relative' }}
          className="col-span-full"
        >
          <Asset resource={image as AssetType} imgClassName="w-full object-contain" />
        </div>
      </Grid>
    </Container>
  )
}
